export const authValidationMessages = {
  email: {
    placeholder: '이메일을 입력해주세요.',
    invalidFormat: '정확한 이메일을 입력해주세요.',
    userNotFound: '가입되지 않은 이메일입니다.',
    duplicatedId: '이미 가입된 이메일입니다.'
  },
  storeName: {
    placeholder: '병원명 또는 이름을 입력해주세요.',
    error: '병원명 또는 이름을 입력해주세요.'
  },
  appUserName: {
    placeholder: '이름을 입력해주세요.',
    error: '이름을 입력해주세요.'
  },
  phone: {
    placeholder: '연락 가능한 휴대전화 번호를 숫자만 입력해주세요.',
    notAnumber: '올바른 휴대전화 번호를 숫자만 입력해 주세요.'
  },
  termsAgreement: {
    title: '전체 약관 동의',
    unconfirmed: '필수 약관 모두에 동의해주세요'
  },
  otp: {
    placeholder: '인증번호를 입력해주세요.',
    invalidFormat: '유효하지 않은 인증번호입니다.',
    resend: '이메일과 휴대전화로 인증번호를 재발송하였습니다.',
    base: '이메일과 휴대전화로 인증번호를 발송했습니다.',
    sendFail: '인증번호를 전송하지 못했습니다.',
    incorrect: '인증번호가 일치하지 않습니다.',
    setSendMessageWithPhonenumber: (phoneNumber: string) => `${phoneNumber?.trim() === '' ? '' : phoneNumber + '와 '}이메일로 OTP를 전송했습니다.`
  }
};
